// Global
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';

// Lib
import { ComponentProps } from 'lib/component-props';
import { SearchComponents } from 'lib/templates/Feature.Dart.model';
import { DartPages } from 'lib/templates/Project.Dart.model';

// Local
import Container from 'components/authorable/Layout/DartContainer/DartContainer';
import { useRealPathName } from 'lib/utils/use-real-pathname';
import { sendGTMEvent } from '@next/third-parties/google';
import PIDSResultsListwithSearchWidget from 'components/PIDSResultsListwithSearch';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

export type PIDSResultsListProps = ComponentProps &
  SearchComponents.PidsResultsListWithSearch.PidsResultsListWithSearch;

export const PIDSResultsListwithSearch = (props: PIDSResultsListProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const pidsListingPage = sitecoreContext?.route as DartPages.PidsListingPage;
  const [count, setCount] = useState(0);

  const router = useRouter();
  const path = useRealPathName();

  useEffect(() => {
    setCount((c) => c + 1);
  }, [router]);

  // Add ref for the GTM Event
  const hasFired = useRef(false);

  useEffect(() => {
    // Function to send the GTM event
    sendGTMEvent({ event: 'switcher', type: 'click', value: 'grid' });
    hasFired.current = true;
  }, []); // Empty dependency array ensures it runs only once on mount

  if (!props?.fields) return <></>;

  const pidsResultsData = {
    resultsPerPage: props?.fields?.resultsPerPage,
    noResult: props?.fields?.noResult,
    displayResult: props?.fields?.displayResult,
    prevLabel: props?.fields?.prevLabel,
    nextLabel: props?.fields?.nextLabel,
    pidsLabel: pidsListingPage?.fields?.pidsLabel,
    sdsLabel: pidsListingPage?.fields?.sdsLabel,
    pidsValidFromLabel: pidsListingPage?.fields?.pidsValidFromLabel,
    pidsValidToLabel: pidsListingPage?.fields?.pidsValidToLabel,
    sdsValidFromLabel: pidsListingPage?.fields?.sdsValidFromLabel,
    sdsValidToLabel: pidsListingPage?.fields?.sdsValidToLabel,
    itemId: sitecoreContext?.route?.itemId?.replace(/-/g, '').toUpperCase(),
  };

  // Unique id for component
  const id = props?.params?.RenderingIdentifier;

  return (
    <Container>
      <div
        data-component="layout/productresultslistwithsearch"
        id={id ? id : undefined}
        tabIndex={id ? -1 : 1}
      >
        <div>
          <PIDSResultsListwithSearchWidget
            rfkId={'rfkid_12'}
            {...pidsResultsData}
            key={path + count}
          />
        </div>
      </div>
    </Container>
  );
};

export default PIDSResultsListwithSearch;
